export default function MyProfilePersonalInfo({ employee, getDictionaryValue, getDictionaryTypeValues, editMode, setValue }) {
  if (!employee) {
    return <div className="loading">Loading...</div>;
  }

  const pronounOptions = getDictionaryTypeValues ? getDictionaryTypeValues("Pronouns") : [];

  return (
    <>
      {/* Personal Information + Address Information */}
      <div className="white-box">
        <div className="subtitle">Personal Information</div>
        <div className="row col-2 main-gap">
          <div className="label-row">
            <label>Personal Email</label>
            <input
              value={employee.personalEmail || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("personalEmail", e.target.value)}
            />
          </div>
          <div className="label-row">
            <label>Personal Number</label>
            <input value={employee.phone || ""} readOnly={!editMode} onChange={(e) => setValue("phone", e.target.value)} />
          </div>
          <div className="label-row">
            <label>Preferred Name</label>
            <input
              value={employee.preferredName || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("preferredName", e.target.value)}
            />
          </div>
          <div className="label-row">
            <label>Pronouns</label>
            {editMode ? (
              <select value={employee._pronouns || ""} onChange={(e) => setValue("_pronouns", e.target.value)}>
                <option value="">—</option>
                {pronounOptions.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.value}
                  </option>
                ))}
              </select>
            ) : (
              <input value={getDictionaryValue("Pronouns", employee._pronouns) || ""} readOnly />
            )}
          </div>
        </div>

        <div className="subtitle mt-30">Address Information</div>
        <div className="row col-2 main-gap">
          <div className="label-row">
            <label>Street Address</label>
            <input value={employee.address || ""} readOnly={!editMode} onChange={(e) => setValue("address", e.target.value)} />
          </div>
          <div className="label-row">
            <label>Apt/Suite</label>
            <input value={employee.aptSuite || ""} readOnly={!editMode} onChange={(e) => setValue("aptSuite", e.target.value)} />
          </div>
          <div className="label-row">
            <label>Town/City</label>
            <input value={employee.city || ""} readOnly={!editMode} onChange={(e) => setValue("city", e.target.value)} />
          </div>
          <div className="label-row">
            <label>State/Providence/Country</label>
            <input value={employee.state || ""} readOnly={!editMode} onChange={(e) => setValue("state", e.target.value)} />
          </div>
          <div className="label-row">
            <label>Country/Region</label>
            <input value={employee.country || ""} readOnly={!editMode} onChange={(e) => setValue("country", e.target.value)} />
          </div>
          <div className="label-row">
            <label>Postal Code</label>
            <input value={employee.zipcode || ""} readOnly={!editMode} onChange={(e) => setValue("zipcode", e.target.value)} />
          </div>
        </div>
      </div>

      {/* Emergency Contact */}
      <div className="white-box">
        <div className="subtitle">Emergency Contact</div>
        <div className="row col-2 main-gap">
          <div className="label-row">
            <label>Name</label>
            <input
              value={employee.emergencyContact || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("emergencyContact", e.target.value)}
            />
          </div>
          <div className="label-row">
            <label>Relationship</label>
            <input
              value={employee.emergencyContactRelationship || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("emergencyContactRelationship", e.target.value)}
            />
          </div>
          <div className="label-row">
            <label>Phone</label>
            <input
              value={employee.emergencyContactPhone || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("emergencyContactPhone", e.target.value)}
            />
          </div>
          <div className="label-row">
            <label>Email</label>
            <input
              value={employee.emergencyContactEmail || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("emergencyContactEmail", e.target.value)}
            />
          </div>
          <div className="label-row">
            <label>Location</label>
            <input
              value={employee.emergencyContactLocation || ""}
              readOnly={!editMode}
              onChange={(e) => setValue("emergencyContactLocation", e.target.value)}
            />
          </div>
          <div className="label-row"></div>
        </div>

        {(editMode ||
          employee.emergencyContact2 ||
          employee.emergencyContact2Relationship ||
          employee.emergencyContact2Phone ||
          employee.emergencyContact2Email ||
          employee.emergencyContact2Location) && (
          <>
            <div className="subtitle mt-30">Emergency Contact 2</div>
            <div className="row col-2 main-gap">
              <div className="label-row">
                <label>Name</label>
                <input
                  value={employee.emergencyContact2 || ""}
                  readOnly={!editMode}
                  onChange={(e) => setValue("emergencyContact2", e.target.value)}
                />
              </div>
              <div className="label-row">
                <label>Relationship</label>
                <input
                  value={employee.emergencyContact2Relationship || ""}
                  readOnly={!editMode}
                  onChange={(e) => setValue("emergencyContact2Relationship", e.target.value)}
                />
              </div>
              <div className="label-row">
                <label>Phone</label>
                <input
                  value={employee.emergencyContact2Phone || ""}
                  readOnly={!editMode}
                  onChange={(e) => setValue("emergencyContact2Phone", e.target.value)}
                />
              </div>
              <div className="label-row">
                <label>Email</label>
                <input
                  value={employee.emergencyContact2Email || ""}
                  readOnly={!editMode}
                  onChange={(e) => setValue("emergencyContact2Email", e.target.value)}
                />
              </div>
              <div className="label-row">
                <label>Location</label>
                <input
                  value={employee.emergencyContact2Location || ""}
                  readOnly={!editMode}
                  onChange={(e) => setValue("emergencyContact2Location", e.target.value)}
                />
              </div>
              <div className="label-row"></div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
